module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAApCAMAAABX0hoSAAAAAXNSR0IB2cksfwAAADNQTFRFAAAAFYD/AID/H3f/H3b/H3b/Hnj/H3b/JG3/IHb//////////////////////////////X0dJAAAABF0Uk5TAAwErsX/Ec8HuhAw72D/oEAMwNNOAAAAwklEQVR4nM3WyRLDIAwDULLQpouh//+13dI2YBFkn8oR5g0DB8kh7K1h97S5xml2yXGK0SOfziPfzi4/zip/zia3ziJL95AHn4vxSEntOIkcIxfo+nA5/ZU7O93lKk6XEpSEg5JyQJJOSdpV0uAK2XAzdBvZcgN2X2l2q3S4l+y4IMil3HVY5taFRbBpmVtPrAKxlnn9VBUWKkgFORCjOoAFOSq4BTmqKgQ5qpwEOaoOBTmqgAU5qvJveNs7ZATbWHMHOt4dqHTsuFsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--logo@2x.png
// module id = 938
// module chunks = 0